import { BridgeConfig } from '../models/interfaces/native-bridge-window';

export const bridgeConfigConstants: BridgeConfig[] = [
  { windowProperty: 'iOSBridge' },
  { windowProperty: 'androidBridge' }
  // Add more bridge configurations as needed
];
